<template>
  <div
    ref="limitedActivityRoot"
    class="limited-time-activity"
    :class="{ 'limited-time-activity--portrait-equal': !isLandscape }"
    id="limitTimeActivity"
    v-if="showTimeAwardList.length"
  >
    <div class="header-wrap">
      <div class="title flex-center">
        <span class="btn-icon" :style="titleIconStyle"></span>
        {{ letter.v3LimitedTimeBenefits }}
      </div>
      <div class="header-btn" @click="showRulePopup(0)">
        <Icon class="btn-icon" name="help" />
        <span>{{ letter.v3EventRules }}</span>
      </div>
    </div>
    <div class="activity-swiper-container swiper-container">
      <div class="swiper-wrapper activity-wrap">
        <div
          class="swiper-slide"
          v-for="(award, index) in showTimeAwardList"
          :key="index"
        >
          <div
            class="activity-item shadow"
            :class="{
              'activity-item--full-mobile': isSingleMobileLimitedActivity
            }"
            @mouseenter="mouseEnter(index)"
            @mouseleave="mouseLeave(index)"
            @touchstart="touchStart(index)"
            @touchend="touchEnd(index)"
            :style="isLandscape ? '' : getBackgroundStyle"
          >
            <div
              class="activity-icon"
              :style="isLandscape ? getBackgroundStyle : ''"
            >
              <img
                :src="award.basic.cover"
                class="activity-img"
                alt="activity-img"
              />
            </div>
            <div class="activity-info">
              <div class="activity-content">
                <p class="activity-content-title">
                  <Icon
                    class="activity-content-title-icon"
                    name="history-query"
                  />
                  <span class="activity-content-title-text">{{
                    award.basic.title
                  }}</span>
                </p>
                <p class="activity-content-desc">
                  <Icon
                    v-if="award.basic && award.basic.desc"
                    class="activity-content-desc-icon"
                    name="icon-web__jiangli"
                  ></Icon>
                  <van-notice-bar
                    :scrollable="scrollableArr[index] || false"
                    :delay="0"
                    :text="award.basic.desc"
                  />
                </p>
              </div>
              <div
                v-show="
                  award.basic.status === TIME_AWART_STATUS.UNFINISHED &&
                  isGoButtonTask(award)
                "
                class="activity-btn flex-center"
                @click="toFinish(award)"
              >
                {{ letter.gotoFinish }}
              </div>
              <div
                v-show="
                  award.basic.status === TIME_AWART_STATUS.UNFINISHED &&
                  !isGoButtonTask(award)
                "
                class="activity-btn flex-center"
                @click="showRulePopup(index)"
              >
                {{ letter.v3ViewDetails }}
              </div>
              <div
                v-show="
                  award.basic.status === TIME_AWART_STATUS.FINISHED &&
                  award.basic.taskType != TIME_AWART_TYPE.REDIRECT
                "
                class="activity-btn flex-center"
                @click="toGetAward(award)"
              >
                {{ letter.v3Claim }}
              </div>
              <div
                v-show="
                  award.basic.status === TIME_AWART_STATUS.FINISHED &&
                  award.basic.taskType === TIME_AWART_TYPE.REDIRECT
                "
                class="activity-btn flex-center"
                @click="toFinish(award)"
              >
                {{ letter.v3GoTo }}
              </div>
              <div
                v-show="award.basic.status === TIME_AWART_STATUS.GOT"
                class="activity-btn disabled flex-center"
              >
                {{ letter.v3Completed }}
              </div>
            </div>
            <div class="activity-counter">
              <Icon class="counter-ico" name="time"></Icon>
              <span class="time">{{
                getCounterTime(award.basic.countdown)
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="activity-pagination"></div>
    </div>
    <transition name="fade">
      <AwardRoleSelect
        :visible="visibleRoleSelect"
        v-show="visibleRoleSelect"
        @close="visibleRoleSelect = false"
        @getAward="getAward"
      ></AwardRoleSelect>
    </transition>
    <transition name="fade">
      <LimitedTimeRulePopup
        :timeAwardList="showTimeAwardList"
        :showRuleIndex="showRuleIndex"
        @onClose="visibleRulePopup = false"
        v-if="visibleRulePopup"
      ></LimitedTimeRulePopup>
    </transition>
    <PopupWindow
      v-if="visibleTipPopup"
      type="tips"
      :languages="letter"
      :content="popupTip"
      textAlign="center"
      @onConfirm="visibleTipPopup = false"
      @onCancel="visibleTipPopup = false"
    ></PopupWindow>
    <transition name="fade">
      <SharePopup
        v-if="visibleSharePopup"
        :shareLimitList="shareLimitList"
        @closeSharePopup="visibleSharePopup = false"
        @shareSuccess="shareSuccess"
      ></SharePopup>
    </transition>
    <!-- 限时任务「保存到桌面 -->
    <transition name="fade">
      <SafariPwaGuidePopup
        v-if="limitedTaskSafariGuideVisible"
        @closePopup="onLimitedTaskSafariGuideClose"
      />
    </transition>
    <transition name="fade">
      <PwaCommonPopup
        v-if="limitedTaskCommonPopupVisible"
        @closePopup="onLimitedTaskCommonPopupClose"
      />
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Swiper from 'swiper';
import AwardRoleSelect from '@components/officialTopupNew/activity/AwardRoleSelect';
import LimitedTimeRulePopup from '@components/officialTopupNew/activity/LimitedTimeRulePopup.vue';
import SharePopup from '@components/officialTopupNew/activity/SharePopup.vue';
import { GET_FB_APPID } from '@store/officialTopupNew/index';
import {
  TIME_AWART_TYPE,
  JUMP_TYPE,
  GET_TIME_AWARD,
  TIME_AWART_STATUS,
  FINISH_REDIRECT,
  FINISH_SHARE,
  FINISH_SAVE_DESKTOP
} from '@store/officialTopupNew/activity';
import { UPDATE_IS_LOGIN_POPUP } from '@store/officialTopupNew/login';
import product from '@mixins/officialTopupNew/product';
import style from '@mixins/officialTopupNew/style';
import { countDownTimeFormat } from '@utiles/officialStore';
import {
  OPEN_BROWSER,
  OPEN_WEBVIEW,
  sdkOpenLink
} from '@utiles/officialStore/sdkCtrl';
import {
  clickButton,
  timePoint,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV35';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import {
  UPDATE_IS_INSTALL,
  UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP
} from '@store/officialTopupNew/page';
import pwaMixin from '@mixins/pwa';
import globalConfig from '@utiles/officialStore/globalConfig';
import { isSafari } from '@utiles/officialStore/device';
import SafariPwaGuidePopup from '@components/officialTopupNew/pwa/SafariPwaGuidePopup.vue';
import PwaCommonPopup from '@components/officialTopupNew/pwa/PwaCommonPopup.vue';
export default {
  name: 'limitedTimeActivity',
  mixins: [product, style, pwaMixin],
  data() {
    return {
      isSafariBrowser: isSafari(),
      limitedTaskSafariGuideVisible: false,
      limitedTaskCommonPopupVisible: false,
      swiper: null,
      //准备领奖的活动
      toGetActivity: null,
      toFinishActivity: null,
      shareLimitList: [],

      visibleSharePopup: false,
      visibleRoleSelect: false,
      visibleRulePopup: false,
      showRuleIndex: 0,
      visibleTipPopup: false,
      showMorePopup: false,
      popupTip: '',
      TIME_AWART_STATUS: TIME_AWART_STATUS,
      toDoList: [
        TIME_AWART_TYPE.SHARE,
        TIME_AWART_TYPE.REDIRECT,
        TIME_AWART_TYPE.SAVE_DESKTOP,
        TIME_AWART_TYPE.FIRST_PAY,
        TIME_AWART_TYPE.TOTAL_PAY
      ],
      TIME_AWART_TYPE: TIME_AWART_TYPE,
      scrollableArr: [],
      _limitedActivityRo: null,
      _limitedActivityRoTimer: null
    };
  },
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape,
      lang: state => state.lang,
      letter: state => state.letter,
      timeAwardList: state => state.activity.timeAwardList,
      isLogin: state => state.login.isLogin,
      picList: state => state.page.picList,
      isInstall: state => state.page.isInstall,
      gameId: state => state.gameId
    }),
    ...mapGetters(['showTimeAwardList', 'isJpPlatform']),
    /** 移动端竖屏且仅 1 条限时任务时，卡片铺满宽度 */
    isSingleMobileLimitedActivity() {
      return !this.isLandscape && this.showTimeAwardList.length === 1;
    },
    /** 当前环境是否具备「保存到桌面 / 添加到主屏幕」能力 */
    saveDesktopCanInstall() {
      if (this.isJpPlatform || this.isHideAdd) {
        return false;
      }
      if (isSafari()) {
        return true;
      }
      return this.isPwaSupported;
    },
    isHideAdd() {
      const scid = globalConfig.getHrefParam('scid') || '';
      return (
        globalConfig.getHrefParam('cid') === 'shortcut' ||
        scid.includes('shortcut') ||
        scid === 'newpwa' ||
        globalConfig.getHrefParam('mode') === 'pwa'
      );
    },
    titleIconStyle() {
      return `background-image: url(${this.picList?.limitProductIcon})`;
    },
    getBackgroundStyle() {
      if (this.picList?.giftmissionbg) {
        return {
          backgroundImage: `url(${this.picList?.giftmissionbg})`
        };
      }
      return {};
    },
    getCounterTime() {
      return countdown => {
        const { days, hours, minutes, seconds } =
          countDownTimeFormat(countdown);
        return `${days}d ${hours}:${minutes}:${seconds}`;
      };
    }
  },
  watch: {
    // isInstall: {
    //   deep: true,
    //   handler() {
    //     this.tryFinishSaveDesktopByInstall();
    //   }
    // },
    timeAwardList: {
      handler(newVal) {
        if (!newVal.length) return;
        this.$nextTick(() => {
          this.initSwiper();
          this.finishSaveDesktopTaskFromPwaLaunch();
        });
      }
    },
    isLogin: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => this.finishSaveDesktopTaskFromPwaLaunch());
        }
      }
    },
    isLandscape: {
      handler() {
        // 横竖屏切换时重新初始化Swiper
        if (this.swiper && this.showTimeAwardList.length) {
          this.$nextTick(() => {
            this.initSwiper();
          });
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch(GET_FB_APPID);
    if (this.showTimeAwardList.length) {
      this.$nextTick(() => {
        this.initSwiper();
      });
    }
    this.$nextTick(() => {
      this.setupLimitedActivityHeightObserver();
      this.finishSaveDesktopTaskFromPwaLaunch();
    });
  },
  beforeDestroy() {
    if (this._limitedActivityRo) {
      this._limitedActivityRo.disconnect();
      this._limitedActivityRo = null;
    }
    clearTimeout(this._limitedActivityRoTimer);
    if (this.$refs.limitedActivityRoot) {
      this.$refs.limitedActivityRoot
        .querySelectorAll('.activity-item')
        .forEach(el => {
          el.style.minHeight = '';
          el.style.height = '';
        });
    }
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  },
  methods: {
    /**
     * 各 slide 卡片统一为当前列表中的最大自然高度，避免标题换行导致高低不一
     * 横屏用 height 以便 info 区 flex 撑满、按钮底对齐；竖屏用 minHeight
     */
    syncLimitedActivitySlideHeights() {
      const root = this.$refs.limitedActivityRoot;
      if (!root) return;
      const items = root.querySelectorAll('.activity-item');
      if (!items.length) return;

      items.forEach(el => {
        el.style.minHeight = '';
        el.style.height = '';
      });

      requestAnimationFrame(() => {
        let max = 0;
        items.forEach(el => {
          max = Math.max(max, el.offsetHeight);
        });
        if (max > 0) {
          items.forEach(el => {
            if (this.isLandscape) {
              el.style.height = `${max}px`;
            } else {
              el.style.minHeight = `${max}px`;
            }
          });
        }
        this.$nextTick(() => {
          if (this.swiper) this.swiper.update();
        });
      });
    },
    setupLimitedActivityHeightObserver() {
      if (typeof ResizeObserver === 'undefined') return;
      this.$nextTick(() => {
        const root = this.$refs.limitedActivityRoot;
        if (!root) return;
        if (this._limitedActivityRo) {
          this._limitedActivityRo.disconnect();
        }
        this._limitedActivityRo = new ResizeObserver(() => {
          clearTimeout(this._limitedActivityRoTimer);
          this._limitedActivityRoTimer = setTimeout(() => {
            this.syncLimitedActivitySlideHeights();
          }, 80);
        });
        this._limitedActivityRo.observe(root);
      });
    },
    isGoButtonTask(award) {
      const t = award?.basic?.taskType;
      return this.toDoList.includes(t);
    },
    tryFinishSaveDesktopByInstall(activity) {
      if (
        activity.basic.taskType === TIME_AWART_TYPE.SAVE_DESKTOP &&
        activity.basic.status === TIME_AWART_STATUS.UNFINISHED
      ) {
        this.finishSaveDesktopTask(activity);
      }
    },
    finishSaveDesktopTaskFromPwaLaunch() {
      if (!this.isLogin || !this.isHideAdd) {
        return;
      }
      const list = this.showTimeAwardList || [];
      list.forEach(award => {
        if (
          award?.basic?.taskType === TIME_AWART_TYPE.SAVE_DESKTOP &&
          award.basic.status === TIME_AWART_STATUS.UNFINISHED
        ) {
          this.finishSaveDesktopTask(award);
        }
      });
    },
    finishSaveDesktopTask(award) {
      if (
        !this.isLogin ||
        !award ||
        award.basic.status !== TIME_AWART_STATUS.UNFINISHED
      ) {
        return Promise.resolve();
      }
      return this.$store
        .dispatch(FINISH_SAVE_DESKTOP, award.enname)
        .then(res => {
          if (res.code === 1) {
            award.basic.status = TIME_AWART_STATUS.FINISHED;
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    /**
     * 限时任务「保存到桌面」：独立调起安装/引导
     */
    runSaveDesktopForLimitedTask(activity) {
      if (this.shouldShowPwaTips()) {
        this.isSafariBrowser
          ? this.openLimitedTaskSafariGuide('limited_task', activity)
          : this.openLimitedTaskCommonPopup('limited_task', activity);
      } else {
        this.limitedTaskInstallPwa('limited_task', activity);
      }
    },
    sendLimitedTaskAddToHomePoint(from) {
      clickButton({
        btnName: 'add_to_screen',
        locationKey: this.$route.meta.pageName,
        otherParams: from === 'limited_task' ? 4 : 1
      });
    },
    openLimitedTaskSafariGuide(from, activity) {
      this.limitedTaskSafariGuideVisible = true;
      this.sendLimitedTaskAddToHomePoint(from);
      showPopup(popupType.safariAddToHomePopup);
      this.$nextTick(() => {
        this.tryFinishSaveDesktopByInstall(activity);
      });
    },
    onLimitedTaskSafariGuideClose() {
      this.limitedTaskSafariGuideVisible = false;
    },
    openLimitedTaskCommonPopup(from, activity) {
      this.sendLimitedTaskAddToHomePoint(from);
      this.limitedTaskCommonPopupVisible = true;
      this.$nextTick(() => {
        this.tryFinishSaveDesktopByInstall(activity);
      });
    },
    onLimitedTaskCommonPopupClose() {
      this.limitedTaskCommonPopupVisible = false;
    },
    limitedTaskInstallPwa(from, activity) {
      this.sendLimitedTaskAddToHomePoint(from);
      if (!window.deferredPrompt) {
        return;
      }
      window.deferredPrompt.prompt();
      window.deferredPrompt.userChoice
        .then(result => {
          if (result.outcome === 'dismissed') {
          } else if (result.outcome === 'accepted') {
            if (typeof window.setIsInstall === 'function') {
              window.setIsInstall();
            }
            this.$store.commit(UPDATE_IS_INSTALL, true);
            window.deferredPrompt = null;
            this.$nextTick(() => {
              this.$store.commit(UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP, true);
            });
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    mouseEnter(index) {
      this.scrollableArr[index] = true;
    },
    mouseLeave(index) {
      this.scrollableArr[index] = false;
    },
    touchStart(index) {
      this.scrollableArr[index] = true;
    },
    touchEnd(index) {
      this.scrollableArr[index] = false;
    },
    showTipPopup(content) {
      this.popupTip = content;
      this.visibleTipPopup = true;
    },
    toFinish(activity) {
      this.toFinishActivity = activity;
      if (!this.isLogin) {
        return this.$store.commit(UPDATE_IS_LOGIN_POPUP, true);
      }
      switch (activity.basic.taskType) {
        case TIME_AWART_TYPE.SHARE:
          // 如果是指定分享渠道，需要传入分享渠道列表
          if (activity.basic.taskDetail === 'appoint') {
            this.shareLimitList = activity.basic.shareChannelList;
          } else {
            this.shareLimitList = [];
          }
          this.visibleSharePopup = true;
          break;
        case TIME_AWART_TYPE.SAVE_DESKTOP:
          this.runSaveDesktopForLimitedTask(activity);
          break;
        case TIME_AWART_TYPE.REDIRECT:
          this.$store.dispatch(FINISH_REDIRECT, activity.enname).then(res => {
            if (res.code === 1) {
              timePoint({
                activityName: 'go_link',
                eventValue: {
                  title: activity.basic.title,
                  link: activity.basic.redirectLink,
                  type: activity.type,
                  activityId: activity.enname
                }
              });
              activity.basic.status = TIME_AWART_STATUS.FINISHED;
              if (activity.basic.redirectType == JUMP_TYPE.SELF) {
                sdkOpenLink({
                  link: getGlobalGetGotoLink({
                    link: activity.basic.redirectLink
                  }),
                  openWay: OPEN_WEBVIEW
                });
              }
              if (activity.basic.redirectType == JUMP_TYPE.BLANK) {
                sdkOpenLink({
                  link: getGlobalGetGotoLink({
                    link: activity.basic.redirectLink
                  }),
                  openWay: OPEN_BROWSER
                });
              }
            }
          });
          break;
        case TIME_AWART_TYPE.FIRST_PAY:
          this.jumpToPaySection();
          break;
        case TIME_AWART_TYPE.TOTAL_PAY:
          this.jumpToPaySection();
          break;
        default:
          break;
      }
    },
    jumpToPaySection() {
      this.$nextTick(() => {
        const el = document.getElementById('j-product-list');
        if (!el || typeof el.scrollIntoView !== 'function') return;
        // 顶栏留白由 SelectProduct 内 #j-product-list 的 scroll-margin-top 负责
        // 使用布尔参数兜底：部分 WebView 不支持 scrollIntoView(options)
        try {
          el.scrollIntoView({
            block: 'start',
            inline: 'nearest',
            behavior: 'auto'
          });
        } catch (_e) {
          el.scrollIntoView(true);
        }
      });
    },
    showRulePopup(index) {
      this.showRuleIndex = index || 0;
      this.visibleRulePopup = true;
    },
    shareSuccess(name) {
      const enname = this.toFinishActivity?.enname;
      if (!enname) return;
      this.$store.dispatch(FINISH_SHARE, enname).then(res => {
        if (res.code === 1) {
          this.toFinishActivity.basic.status = TIME_AWART_STATUS.FINISHED;
          this.showTipPopup(this.letter.v3ShareSuccess);
        } else {
          this.showTipPopup(`[${res.code}]${this.letter.v3ShareFailure}`);
        }
      });
    },
    initSwiper() {
      try {
        this.swiper && this.swiper.destroy();
        this.swiper = new Swiper('.activity-swiper-container', {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: this.isLandscape ? 20 : 20,
          pagination: {
            el: '.activity-pagination',
            clickable: true
          },
          effect: 'slide',
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          resizeObserver: true,
          watchOverflow: true,
          updateOnWindowResize: true,
          on: {
            resize: () => {
              if (this.swiper) {
                this.swiper.update();
                this.syncLimitedActivitySlideHeights();
              }
            }
          }
        });
        this.$nextTick(() => {
          this.syncLimitedActivitySlideHeights();
        });
      } catch (error) {
        console.error(error);
      }
    },
    toGetAward(activity) {
      this.toGetActivity = activity;
      this.visibleRoleSelect = true;
    },
    async getAward(role) {
      const res = await this.$store.dispatch(GET_TIME_AWARD, {
        name: this.toGetActivity.enname,
        ...role
      });
      if (res.code === 1) {
        this.toGetActivity.basic.status = TIME_AWART_STATUS.GOT;
        this.showTipPopup(this.letter.v3RewardClaimed);
      } else {
        this.showTipPopup(`[${res.code}]${this.letter.v3RewardClaimFailed}`);
      }
      this.visibleRoleSelect = false;
    }
  },
  components: {
    AwardRoleSelect,
    LimitedTimeRulePopup,
    SharePopup,
    SafariPwaGuidePopup,
    PwaCommonPopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.limited-time-activity {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  margin-bottom: 10px;

  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    line-height: 1.1;
    .title {
      font-weight: bold;
      white-space: normal;
      .btn-icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
      }
    }
    .header-btn {
      display: flex;
      align-items: center;
      font-size: 24px;
      white-space: nowrap;
      cursor: pointer;

      .btn-icon {
        width: 26px;
        height: 26px;
      }
    }
  }

  .activity-swiper-container {
    position: relative;
    text-align: center;
    margin: -10px;
    padding: 10px 10px 40px;

    .activity-pagination {
      position: absolute;
      bottom: 10px;
    }
    ::v-deep .swiper-pagination-bullet {
      width: 16px;
      height: 16px;
      background: #cccccc;
      &.swiper-pagination-bullet-active {
        background: $themeColor;
      }
    }
  }
  .activity-wrap {
    display: flex;

    .swiper-slide {
      width: auto;
      height: auto;
      box-sizing: border-box;
    }

    .activity-item {
      overflow: hidden;
      position: relative;
      flex-shrink: 0;
      width: 615px;
      height: auto;
      align-items: flex-start;

      &--full-mobile {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
      }
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      background-size: 100% 100%;

      .activity-counter {
        position: absolute;
        top: 10px;
        left: 10px;
        padding: 0 10px;
        line-height: 1.5;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-radius: 16px 0 16px 0px;
        background: linear-gradient(
          348deg,
          $buttonGradientColor1,
          $buttonGradientColor2
        );
        .counter-ico {
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          margin-right: 10px;
          color: #ffffff;
        }
        .time {
          word-break: break-word;
          color: #ffffff;
          font-size: 20px;
          text-align: start;
        }
      }

      .activity-info {
        min-height: 204px;
        height: auto;
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 35px 20px 20px 0px;
        .activity-content {
          width: 274px;
          line-height: 1.2;
          font-size: 20px;
          word-break: break-word;
          overflow: visible;
          color: $commodityNameColor;
          text-align: left;
          flex-shrink: 0;

          &-title {
            margin-bottom: 10px;
            padding: 0 5px;
            font-size: 27px;
            font-weight: bold;
            display: flex;
            align-items: flex-start;
            &-icon {
              display: inline-block;
              flex-shrink: 0;
              width: 24px;
              height: 24px;
              margin-right: 10px;
              margin-top: 4px;
              font-size: 27px;
              color: $commodityNameColor;
              vertical-align: middle;
            }
            &-text {
              flex: 1;
              min-width: 0;
              word-break: break-word;
            }
          }
          &-desc {
            flex-shrink: 0;
            padding: 0 5px;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            font-size: 18px;
            color: $priceColor;
            display: flex;
            align-items: center;
            &-icon {
              font-size: 18px;
              width: 25px;
              height: 25px;
              color: $priceColor;
              margin-right: 5px;
            }

            ::v-deep .van-notice-bar {
              width: 100%;
              height: 24px;
              padding: 0;
              background-color: transparent;
              font-size: 18px;
              color: $priceColor;
            }
          }
        }
        .activity-btn {
          margin-top: 10px;
          width: 234px;
          padding: 20px 20px;
          background: linear-gradient(
            348deg,
            $buttonGradientColor1,
            $buttonGradientColor2
          );
          border-radius: 9px;
          font-size: 26px;
          line-height: 1.1;
          color: #ffffff;
          cursor: pointer;

          &.disabled {
            filter: grayscale(100%);
            cursor: not-allowed;
          }
        }
      }
    }
  }
}

/* 竖屏统一 slide 高度时，左右两列与卡片同高，避免左侧留白 */
.limited-time-activity--portrait-equal {
  .activity-wrap .activity-item {
    align-items: stretch;
  }
}

.limited-time-activity--portrait-equal .activity-icon {
  height: auto;
  min-height: 204px;
  align-self: stretch;
}

.activity-icon {
  position: relative;
  width: 200px;
  height: 204px;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px 10px 0 0;

  .activity-img {
    max-width: 90%;
    height: 150px;
    margin-top: 30px;
    cursor: pointer;
  }
}

#ssr-page.landscape {
  .limited-time-activity {
    max-width: calc(1507px - 237px - 20px);
    margin-bottom: 10px;

    .header-wrap {
      margin-top: -30px;
      .title {
        padding: 34px 0;
      }
      .header-btn {
        font-size: 20px;

        .btn-icon {
          width: 26px;
          height: 26px;
        }
      }
    }
    .activity-wrap {
      .activity-item {
        width: 296px;
        flex-direction: column;
        justify-content: space-between;
        background-size: cover;
        .activity-icon {
          width: 100%;
        }
        .activity-info {
          flex: 1;
          height: auto;
          min-height: 0;
          background-color: $commodityInfoBgColor;
          justify-content: space-between;
          padding: 20px;
          .activity-btn {
            margin-top: 30px;
            flex-shrink: 0;
          }
          .activity-content {
            width: 100%;
            font-size: 16px;
            background-color: $commodityInfoBgColor;
            &-title {
              padding: 0;
              font-size: unset;
              align-items: center;
              &-icon {
                font-size: unset;
              }
            }
            &-desc {
              padding: 0;
              ::v-deep .van-notice-bar {
                height: 20px;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
